import { useCallback, useEffect, useState } from "react";
import useEventListener from "./useEventListener";

const useDeviceDetection = () => {
	const [device, setDevice] = useState<"Mobile" | "Tablet" | "Desktop">(
		"Desktop",
	);
	const [platform, setPlatform] = useState<
		"iOS" | "Android" | "Windows" | "MacOS" | "Linux" | "Unknown"
	>("Unknown");

	const handleDeviceDetection = useCallback(() => {
		const userAgent = navigator.userAgent.toLowerCase();
		const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(
			userAgent,
		);
		const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(
			userAgent,
		);

		if (isMobile) {
			setDevice("Mobile");
		} else if (isTablet) {
			setDevice("Tablet");
		} else {
			setDevice("Desktop");
		}

		if (userAgent.includes("iphone")) {
			setPlatform("iOS");
		} else if (userAgent.includes("android")) {
			setPlatform("Android");
		} else if (userAgent.includes("windows")) {
			setPlatform("Windows");
		} else if (userAgent.includes("mac")) {
			setPlatform("MacOS");
		} else if (userAgent.includes("linux")) {
			setPlatform("Linux");
		} else {
			setPlatform("Unknown");
		}
	}, []);

	useEventListener("resize", handleDeviceDetection);

	useEffect(() => {
		handleDeviceDetection();
	}, [handleDeviceDetection]);

	return { device, platform };
};

export default useDeviceDetection;
